import { defineComponent as ye, ref as i, computed as a, watch as Ee, customRef as Pe } from "vue";
import { DialogLayout as De, TextInput as Re, SequiterButton as Le, useNavigationEventBus as Oe, INPUT_WIDTH as be, DIALOG_VARIANTS as Be, BUTTON_VARIANTS as Ve, TEXT_INPUT_VARIANTS as _e } from "@ado/acs-standard-library";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { getLayout as W, setShowSignInDialog as Y, resetSignInDialog as X, setShowPolicyDialog as _, setShowMobileMenu as He } from "../../../shared/data/layout/state/index.js";
import { PolicyDialogType as H } from "../../../shared/data/layout/state/index4.js";
import { getLocation as Ne } from "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import { generateLogo as xe } from "../../../shared/data/utilities/logo/index2.js";
import { UserAccountOperationStatus as l } from "../../api/types/index2.js";
import { signIn as Ue, createAccount as ke, recoverPassword as Fe, signInSecure as Me } from "../../api/services/index.js";
import qe from "@ado/loading-bar";
import { EmailValidator as $e } from "../types/index2.js";
import { PasswordValidator as Ge } from "../types/index3.js";
import { SignInDialog as z } from "../types/index.js";
import { submitInternalEvent as J } from "@ado/tracking-library";
import { TRACKING_EVENTS as Q } from "../../../shared/data/tracking/types/index.js";
import { Messages as w } from "../types/index5.js";
import { clearUserLicensesInCache as Ke } from "@ado/user-license-service";
import { useBaseApplicationTranslation as je, getGenderContext as We } from "../../../shared/libraries/local-translations/index.js";
import "@ado/loading-bar/style.css";
import "@ado/acs-standard-library/style.css";
var Z = /* @__PURE__ */ ((n) => (n[n.SignIn = 1] = "SignIn", n[n.ResetPassword = 2] = "ResetPassword", n[n.Create = 3] = "Create", n))(Z || {});
const At = ye({
  name: "SignIn",
  components: {
    DialogLayout: De,
    TextInput: Re,
    LoadingBar: qe,
    Button: Le
  },
  props: {
    showDialog: {
      type: Boolean,
      default: !0
    },
    accountCreationLink: {
      type: String,
      default: "/SignIn/?page=create"
    },
    emailValidator: {
      type: Object,
      default: function() {
        return new $e();
      }
    },
    passwordValidator: {
      type: Object,
      default: function() {
        return new Ge();
      }
    },
    signInCompletionHandler: {
      type: Function,
      default: function() {
        return () => {
        };
      }
    },
    resetPasswordCompletionHandler: {
      type: Function,
      default: function() {
        return () => {
        };
      }
    },
    disableSendingSignInRequestsToOtherHosts: {
      type: Boolean,
      default: !1
    },
    config: {
      type: Object,
      required: !0
    }
  },
  setup(n) {
    const ee = Oe(), { t: o } = je(), te = "/SignIn/?page=signin", oe = xe({
      siteBrand: n.config.sitebrand
    }), ne = W().signInDialog === z.Create ? 3 : 1, se = i(
      be.CUSTOM
    ), u = i(void 0), d = i(void 0), h = i(void 0), r = i(ne), S = W().productInfo, I = i(void 0), T = i(void 0), g = i(""), P = i(!1), v = i(!1), A = i(""), C = i(""), y = i([]), E = "sign-in.dialog", N = i(""), ie = Ne(), x = i(!1), U = (e) => {
      r.value = e;
    }, f = a(
      () => r.value === 1
    ), c = a(
      () => r.value === 3
    ), k = a(
      () => r.value === 2
    ), ae = a(
      () => r.value === 1 ? "sign-in-submit" : "reset-password-submit"
    ), D = () => (f.value || c.value) && S, F = () => {
      let e = "";
      return D() ? e = o("sign-in.save-document") : f.value || c.value ? e = o("sign-in.sign-in") : e = o("sign-in.password-reset"), e;
    }, M = i(F());
    Ee(
      () => r.value,
      () => {
        M.value = F();
      },
      { immediate: !0 }
    );
    const re = a(
      () => c.value ? o("sign-in.create-password") : o("sign-in.password")
    ), ce = a(
      () => u.value !== void 0
    ), le = a(
      () => d.value !== void 0
    ), ue = a(
      () => h.value !== void 0
    ), q = function() {
      u.value = void 0, d.value = void 0, h.value = void 0;
    }, de = function() {
      I.value = void 0, T.value = void 0, q();
    }, ge = async () => {
      _(!0, H.PrivacyPolicy), J(Q.FOOTER_PRIVACY_POLICY_CLICK);
    }, ve = async () => {
      _(!0, H.EmailPolicy);
    }, fe = async () => {
      _(!0, H.Terms), J(Q.FOOTER_TERMS_OF_USE_CLICK);
    }, R = function() {
      de(), Y(!1), X();
    }, $ = function(e, t, s, m) {
      const p = t.validate(m, e);
      return p.succeeded ? (s.value = void 0, !0) : (s.value = p.error, !1);
    }, G = function(e) {
      return $(e, n.emailValidator, u, o);
    }, L = function(e) {
      return $(e, n.passwordValidator, d, o);
    }, me = () => {
      D() && R(), N.value === "" ? v.value = !1 : window.location.href = N.value;
    }, O = function() {
      f.value ? g.value = o("sign-in.dialog.signing-in") : c.value ? g.value = o("sign-in.dialog.creating-account") : g.value = o("sign-in.dialog.recovery-email"), P.value = !0;
    }, K = function() {
      P.value = !1;
    }, b = function() {
      A.value = w.getErrorAlertTitle(o), y.value = w.getCommonErrorMessage(o), C.value = "", v.value = !0;
    }, pe = function(e, t, s) {
      A.value = w.getSuccessAlertTitle(o);
      const m = We(t);
      C.value = o(
        `${E}.answer-saved-header${m}`,
        {
          productName: e
        }
      );
      let p = o(
        `${E}.signed-in.answer-saved-message${m}`,
        {
          siteBrand: n.config.sitebrand,
          productName: e
        }
      );
      s === "create" && (p = o(`${E}.create-account.answer-saved-message`, {
        siteBrand: n.config.sitebrand
      })), y.value = [
        p,
        o(`${E}.answer-saved-message1${m}`, {
          productName: e
        })
      ], v.value = !0;
    }, we = function() {
      A.value = w.getSuccessAlertTitle(o), C.value = o("sign-in.password-email-sent"), y.value = w.getResettingPasswordSuccessMessage(
        I.value ?? "",
        o
      ), v.value = !0;
    }, B = function() {
      K(), b();
    }, he = function(e, t) {
      if (!n.disableSendingSignInRequestsToOtherHosts)
        for (const s of t)
          Me(e, s).catch(() => {
          });
    }, j = (e) => {
      const t = e.result, s = {
        username: t?.username ?? "",
        secureId: t?.secureId ?? "",
        loginId: t?.loginIdHash ?? "",
        hasFreeAccount: t?.hasFreeAccount ?? !0
      };
      He(!1), n.signInCompletionHandler(s), Ke(), he(s.secureId, t?.otherHosts ?? []);
    }, V = function(e) {
      K(), e === void 0 ? b() : e.succeeded ? k.value ? (we(), n.resetPasswordCompletionHandler()) : D() ? (x.value = !0, pe(S?.productName ?? "", "", "create"), j(e)) : (g.value = o("sign-in.dialog.signing-in"), j(e), R()) : e.status === l.InvalidUsername || e.status === l.AccountAlreadyExists ? u.value = e.statusDescription : e.status === l.InvalidPassword ? d.value = e.statusDescription : e.status === l.AccountLocked || e.status === l.GeneralError ? (e.status === l.AccountLocked && U(2), h.value = e.statusDescription) : b();
    }, Se = function(e, t) {
      Ue(e, t).then(V).catch(B);
    }, Ie = function(e, t, s = {}) {
      ke(e, t ?? "", s).then(V).catch(B);
    }, Te = function(e) {
      Fe(e).then(V).catch(B);
    }, Ae = function() {
      q();
      const e = I.value ?? "";
      if (!!G(e))
        if (f.value) {
          const t = T.value;
          if (!L(t))
            return;
          O(), Se(e, t ?? "");
        } else if (c.value) {
          const t = T.value, s = {
            countryCode: ie.currentCountry.countryCode,
            source: "D",
            isSendingEmailsAllowed: !0,
            isSendingPromotionsAllowed: !0,
            websiteLinkHash: null,
            ...S
          };
          if (!L(t))
            return;
          O(), Ie(
            e,
            t ?? "",
            s
          );
        } else
          O(), Te(e);
    }, Ce = Pe((e, t) => ({
      get() {
        return e(), n.showDialog;
      },
      set(s) {
        Y(s), s || X(), t();
      }
    }));
    return {
      navigationEventBus: ee,
      handleSubmitButtonClick: Ae,
      currentSection: r,
      productInfo: S,
      email: I,
      password: T,
      headerLogo: oe,
      emailError: u,
      passwordError: d,
      generalError: h,
      shouldShowLoading: P,
      loadingMessage: g,
      isSignInSectionShown: f,
      isResetPasswordSectionShown: k,
      shouldShowEmailError: ce,
      shouldShowPasswordError: le,
      shouldShowGeneralError: ue,
      shouldShowDialog: Ce,
      closeDialog: R,
      validateEmail: G,
      validatePassword: L,
      submitButtonClass: ae,
      DIALOGVARIANTS: Be,
      showAlert: v,
      alertTitle: A,
      alertHeaderText: C,
      alertSecondaryText: y,
      BUTTONVARIANTS: Ve,
      INPUTVARIANTS: _e,
      textInputWidth: se,
      t: o,
      handleAlertDialogButtonClick: me,
      SignInDialog: z,
      submitButtonText: M,
      currentPasswordText: re,
      accountLoginLink: te,
      showTermsOfUseDialog: fe,
      showEmailPolicyDialog: ve,
      showPrivacyPolicyDialog: ge,
      isCreateAccountSectionShown: c,
      changeSection: U,
      Sections: Z,
      hideDialogOnly: x
    };
  }
});
export {
  At as default
};
//# sourceMappingURL=index4.js.map
